import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        selected: {},
    },
    getters: {
        items: state => state.items,
        selected: state => state.selected,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setSelected(state, selected) {
            state.selected = selected;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('postfix/mailboxes', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('postfix/mailboxes', payload);

            return response;
        },
        async update({ commit, state }, payload) {
            const response = await http.patch(`postfix/mailboxes/${state.selected.email}`, payload);

            return response;
        },
        async updateAlias({ commit }, payload) {
            const response = await http.patch(`postfix/mailboxes/${payload.username}/alias`, payload);

            return response;
        },
        async activate({ commit }, id) {
            const response = await http.patch(`postfix/mailboxes/${id}/activate`);

            return response;
        },
        async deactivate({ commit }, id) {
            const response = await http.patch(`postfix/mailboxes/${id}/deactivate`);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`postfix/mailboxes/${id}`);

            return response;
        }
    }
}